import { render, staticRenderFns } from "./repairDetailEvent.vue?vue&type=template&id=4ee62fe6"
import script from "./repairDetailEvent.vue?vue&type=script&lang=js"
export * from "./repairDetailEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports